<script>
import Vue from "vue";
import axios from "axios";

import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import Swal from "sweetalert2";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      list_error_messages: [],
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      this.list_error_messages = []
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        Vue.swal({
          icon: "info",
          title: "Loading ...",
          showConfirmButton: false,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
        
        axios.post(process.env.VUE_APP_API + "/login", {
          username: this.username,
          password: this.password,
        })
        .then(async (res) => {

          Vue.swal.close();

          Vue.swal({
            icon: "success",
            title: "Successfully login!",
            showConfirmButton: false,
            timer: 2000
          });
          
          this.tryingToLogIn = false;
          this.isAuthError = false;

          //store token to local storage
          await localStorage.setItem("authToken", res.data.data.access_token);
          this.$store.commit('auth/SET_CURRENT_USER', true);

          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "dashboard",
            }
          );
        })
        .catch((err) => {
          Vue.swal.close();

          this.tryingToLogIn = false;
          this.isAuthError = true;

          if('response' in err){
            if('data' in err.response){
              if('message' in err.response.data){
                this.list_error_messages.push(err.response.data.message)
              }
            }
          }
        })
      }
    },
    navigateToLanding() {
      this.$router.push({
        name: "default",
      });
    },
    navigateToLogin() {
      this.$router.push({
        name: "login",
      });
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="home-btn d-block float-end">
      <span class="me-3 pointer" @click="navigateToLanding()">
        <i class="fas fa-home h2"></i>
      </span>

      <span class="pointer" @click="navigateToLogin()">
        <i class="fas fa-user h2"></i>
      </span>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p>Sign in to continue to Avava Diary.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-white">
                    <img src="@/assets/images/logo-dark.png" alt height="80" />
                  </span>
                </div>
              </router-link>
            </div>
            
            <b-alert class="mb-1" show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
              {{ err }}
            </b-alert>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Username"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="text"
                  placeholder="Enter username"
                  :class="{ 'is-invalid': submitted && $v.username.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.username.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.username.required">Username is required.</span>
                  <span v-if="!$v.username.username">Please enter valid username.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Remember me
                </b-form-checkbox>
              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Log In</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Avava Diary. All Rights Reserved.
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>